module.exports = __webpack_public_path__ + "img/csm_Geschichte_Einst-und-heute_02_9b52b26651.a6a668a4.jpg";